import React from 'react';
import cx from 'classnames';

import { Close } from '@design-systems/icons';
import useId from '@mc/hooks/useId';
import { useDsTranslateMessage } from '@mc/wink/internationalization/useDsTranslateMessage';

import ButtonOrLink from '../ButtonOrLink';
import stylesheet from './Tag.css';

export type TagProps = {
  appearance?: 'dismissible';
  children: React.ReactNode;
  href?: string;
  onClick?: $TSFixMeFunction;
  size?: 'small' | 'large' | 'x-large';
  disabled?: boolean;
  className?: string;
  onKeyDown?: React.KeyboardEventHandler<HTMLButtonElement | HTMLSpanElement>;
};

const Tag = React.forwardRef<$TSFixMe, TagProps>(function Tag(
  {
    appearance,
    className,
    children,
    href,
    onClick,
    onKeyDown,
    size = 'large',
    disabled = false,
    ...props
  },
  ref,
) {
  const isInteractive = onClick || href;
  const TagType = isInteractive ? ButtonOrLink : 'span';
  const removeId = useId();

  // Translation for default text
  const removeTagText = useDsTranslateMessage({
    id: 'mcds.tag.remove_tag_text',
    defaultMessage: 'Remove Tag',
  });

  return (
    <TagType
      ref={ref}
      className={cx(
        stylesheet.root,
        appearance === 'dismissible' && stylesheet.dismissible,
        isInteractive && stylesheet.interactive,
        stylesheet[size],
        disabled ? stylesheet.disabled : '',
        className,
      )}
      onClick={onClick}
      onKeyDown={onKeyDown}
      href={href}
      aria-describedby={appearance === 'dismissible' ? removeId : undefined}
      {...props}
    >
      {children}
      {appearance === 'dismissible' && (
        <React.Fragment>
          <Close className={stylesheet.crossIcon} />
          <span hidden id={removeId}>
            {removeTagText}
          </span>
        </React.Fragment>
      )}
    </TagType>
  );
});

export default Tag;
